import { useState } from "react";
import { cloneDeep } from "lodash";

// Hook
import { useSortableTable } from "hooks/useSortableTable";

// Component
import { getPageLimit, sortOrderType, renderTableHeader, sliceDataByPage } from "components/PaginationContainer";

const useTable = (dataList, tableColumn) => {
  const [selectedPage, setSelectedPage] = useState(1);
  const [selectedPageLimit, setSelectedPageLimit] = useState(getPageLimit().default);
  const [tableData, handleSorting] = useSortableTable(dataList, tableColumn);
  const [sortField, setSortField] = useState('');
  const [order, setOrder] = useState(sortOrderType.asc);

  const getTableHeader = () => renderTableHeader(
    tableColumn,
    order, setOrder, sortField, setSortField, handleSorting
  );

  const resetPage = () => {
    setSelectedPage(1);
    setSelectedPageLimit(getPageLimit().default);
  }

  const changePage = (pageNumber) => setSelectedPage(pageNumber);

  const changePageLimit = (page) => setSelectedPageLimit(page);

  const getCurrentPageData = (fractional = true) => {
    if (fractional) {
      return sliceDataByPage(tableData, selectedPage, selectedPageLimit);
    } else {
      return sliceDataByPage(tableData, 1, 0);
    }
  }

  return {
    selectedPage,
    selectedPageLimit,
    tableData,
    getTableHeader,
    resetPage,
    changePage,
    changePageLimit,
    getCurrentPageData
  };
}

export default useTable;